import { useState } from 'react';
import { Routes, Route, Outlet, Navigate } from 'react-router-dom';
import Topbar from './scenes/global/Topbar';
import Sidebar from './scenes/global/Sidebar';
import Dashboard from './scenes/dashboard';
import AllPassengers from './scenes/allPassengers';
import AddPassenger from './scenes/addPassenger';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { ColorModeContext, useMode } from './theme';
import PassengerDetails from './scenes/passengerDetails';
import AddMember from './scenes/addMember';
import AdminLogin from './scenes/adminLogin';
import ImportPassenger from './scenes/importPassenger';
import TravelCountry from './scenes/allCountry';
import AddCountry from './scenes/addCountry';
import Excursion from './scenes/excursion';
import AddExcursion from './scenes/addExcursion';
import ExcursionDuplicate from './scenes/excursion/ExcursionDuplicate';
import CountryDetails from './scenes/countryDetails';
import ExcursionDetails from './scenes/ExcursionDetails';
import ExcursionGallery from './scenes/excursionGallery';
import AllPackages from './scenes/packages/allPackages';
import PackageDetails from './scenes/packages/packageDetails';
import AddPackage from './scenes/packages/addPackage';
import PackageOrder from './scenes/packages/packageOrder';
import PackageDuplicate from './scenes/packages/PackageDuplicate';
import AllGuides from './scenes/guide/allGuides';
import AddGuide from './scenes/guide/addGuide';
import ImportGuides from './scenes/guide/importGuides';
import GuideDetails from './scenes/guide/guideDetails';
import AllBookings from './scenes/bookings/allBookings';
import AddBooking from './scenes/bookings/addBooking';
import BookingDetails from './scenes/bookings/bookingDetails';
import BookingInformation from './scenes/bookings/bookingInformation';
import EditPassenger from './scenes/editPassenger';
import AdminAuthentication from './components/AdminAuthentication';
import AllPromotions from './scenes/promotions/allPromotions';
import AddPromotion from './scenes/promotions/addPromotion';
import PromotionDetails from './scenes/promotions/promotionDetails';
import Feedback from './scenes/feedback/Feedback';
import PageNotFound from './components/PageNotFound';
import AddFeedback from './scenes/feedback/AddFeedback';
import FeedbackDetails from './scenes/feedback/FeedbackDetails';
import FeedbackOrder from './scenes/feedback/FeedbackOrder';
import UserFeedbacks from './scenes/userFeedback/UserFeedbacks';
import UserFeedbacksDetails from './scenes/userFeedback/UserFeedbacksDetails';
import Messages from './scenes/messages/Messages';
import AddMessage from './scenes/messages/AddMessage';
import MessageDetails from './scenes/messages/MessageDetails';
import AdditionalBookings from './scenes/bookings/additionalBookings';
import ImportBookings from './scenes/bookings/importBookings';
import AllCountryExcursions from './scenes/countryExcursions/AllCountryExcursions';
import AddCountryExcursion from './scenes/countryExcursions/AddCountryExcursion';
import CountryExcursionDetail from './scenes/countryExcursions/CountryExcursionDetail';
import CountryExcursionDuplicate from './scenes/countryExcursions/CountryExcursionDuplicate';
import AdminUsers from './scenes/admin/AdminUsers';
import AddAdminUser from './scenes/admin/AddAdminUser';
import AdminUserDetail from './scenes/admin/AdminUserDetail';
import CoordinatorView from './scenes/admin/CoordinatorView';
import AdminAccess from './components/AdminAccess';
import PermissionGuard from './components/PermissionGuard';
import Roles from './scenes/roles/Roles';
import RoleForm from './scenes/roles/RoleForm';
import PrivacyPolicy from './scenes/privacyPolicy/PrivacyPolicy';
import AppConfiguration from './scenes/appConfiguration';
import Reports from './scenes/reports';
import ReportDetails from './scenes/reports/ReportDetails';
import ViewReport from './scenes/reports/ViewReport';
import DestinationReports from './scenes/reports/DestinationReports';
import DestinationReportDetails from './scenes/reports/DestinationReportDetails';
import DestinationGuideReport from './scenes/reports/DestinationGuideReport';
import GuidePerformanceReport from './scenes/reports/GuidePerformanceReport';
import ExcursionAttendanceReport from './scenes/reports/ExcursionAttendanceReport';
import ExcursionSummaryReport from './scenes/reports/ExcursionSummaryReport';
import CoordinatorReports from './scenes/reports/CoordinatorReports';
import CoordinatorReportDetails from './scenes/reports/CoordinatorReportDetails';
import CoordinatorDestinationReport from './scenes/reports/CoordinatorDestinationReport';
import CoordinatorMyReports from './scenes/reports/CoordinatorMyReports';
import AssignedTrips from './scenes/assignedTrips/AssignedTrips';
import AssignedTripDetails from './scenes/assignedTrips/AssignedTripDetails';
import ReportsByUser from './scenes/reportsByUser';
import UserReportDetails from './scenes/reportsByUser/UserReportDetails';
import TripReportsList from './scenes/tripReports';
import TripReportEdit from './scenes/tripReports/TripReportEdit';
import TripReportView from './scenes/tripReports/TripReportView';
import AccountDeletion from './scenes/accountDeletion/AccountDeletion';
import SendNotification from './scenes/notifications/SendNotification';
import SurveyResultsReport from './scenes/reports/SurveyResultsReport';
import SurveyResponsesReport from './scenes/reports/SurveyResponsesReport';

function App() {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          <Routes>
            <Route
              path="/"
              element={
                <AdminAuthentication>
                  <Layout />
                </AdminAuthentication>
              }
            >
              <Route index element={<CoordinatorRedirect />} />
              <Route path="/allpassengers" element={<AllPassengers />} />
              <Route path="/addpassengers" element={<AddPassenger />} />
              {/* <Route path="/importpassengers" element={<ImportPassenger />} /> */}
              <Route path="/passenger/:id" element={<PassengerDetails />} />
              <Route path="/passenger/:id/addmember" element={<AddMember />} />
              <Route path="/passenger/:id/editpassenger" element={<EditPassenger />} />

              <Route path="/countries" element={<TravelCountry />} />
              <Route path="/countries/addcountry" element={<AddCountry />} />
              <Route path="/countries/:id" element={<CountryDetails />} />

              <Route path="/excursions" element={<Excursion />} />
              <Route path="/excursions/addexcursion" element={<AddExcursion />} />
              <Route path="/excursions/:id" element={<ExcursionDetails />} />
              <Route path="/excursions/:id/duplicate" element={<ExcursionDuplicate />} />
              <Route path="/excursions/:id/gallery" element={<ExcursionGallery />} />

              <Route path="/country-excursion" element={<AllCountryExcursions />} />
              <Route path="/country-excursion/add" element={<AddCountryExcursion />} />
              <Route path="/country-excursion/:id" element={<CountryExcursionDetail />} />
              <Route path="/country-excursion/:id/duplicate" element={<CountryExcursionDuplicate />} />

              <Route path="/package" element={<AllPackages />} />
              <Route path="/package/order" element={<PackageOrder />} />
              <Route path="/package/addpackage" element={<AddPackage />} />
              <Route path="/package/:id/duplicate" element={<PackageDuplicate />} />
              <Route path="/package/:id" element={<PackageDetails />} />

              <Route path="/guide" element={<AllGuides />} />
              <Route path="/guide/addguide" element={<AddGuide />} />
              <Route path="/guide/import" element={<ImportGuides />} />
              <Route path="/guide/:id" element={<GuideDetails />} />

              <Route path="/booking" element={<AllBookings />} />
              <Route path="/booking/addBooking" element={<AddBooking />} />
              <Route path="/booking/:id" element={<BookingInformation />} />
              <Route path="/booking/:id/update" element={<BookingDetails />} />
              {/* <Route path="/booking/:id/additional" element={<AdditionalBookings />} /> */}
              <Route path="/booking/import" element={<ImportBookings />} />

              <Route path="/promotion" element={<AllPromotions />} />
              <Route path="/promotion/addpromotion" element={<AddPromotion />} />
              <Route path="/promotion/:id" element={<PromotionDetails />} />

              <Route path="/feedback" element={<Feedback />} />
              <Route path="/feedback/addfeedback" element={<AddFeedback />} />
              <Route path="/feedback/reorder" element={<FeedbackOrder />} />
              <Route path="/feedback/:id" element={<FeedbackDetails />} />

              <Route path="/userfeedback" element={<UserFeedbacks />} />
              <Route path="/userfeedback/:id" element={<UserFeedbacksDetails />} />

              <Route path="/message" element={<Messages />} />
              <Route path="/message/sendmessage" element={<AddMessage />} />
              <Route path="/message/:id" element={<MessageDetails />} />

              <Route path="/privacypolicy" element={<PrivacyPolicy />} />
              <Route path="/configuration" element={<AppConfiguration />} />
              <Route path="/reports/excursion" element={<Reports />} />
              <Route path="/reports" element={<Navigate to="/reports/excursion" replace />} />
              <Route path="/reports/:id" element={<ReportDetails />} />
              <Route path="/reports/view/:id" element={<ViewReport />} />
              <Route path="/reports/excursion-attendance" element={<ExcursionAttendanceReport />} />
              <Route path="/reports/excursion-summary" element={<ExcursionSummaryReport />} />
              <Route path="/reports/destinations" element={<DestinationReports />} />
              <Route path="/reports/destinations/:countryId" element={<DestinationReportDetails />} />
              <Route
                path="/reports/destinations/:countryId/guides/:guideId"
                element={<DestinationGuideReport />}
              />
              <Route path="/reports/guide-performance" element={<GuidePerformanceReport />} />
              <Route path="/reports/survey-results" element={<SurveyResultsReport />} />
              <Route path="/reports/survey-responses" element={<SurveyResponsesReport />} />
              <Route path="/reports/coordinators" element={<CoordinatorReports />} />
              <Route path="/reports/my-reports" element={<CoordinatorMyReports />} />
              <Route path="/assigned-trips" element={<AssignedTrips />} />
              <Route path="/assigned-trips/:countryId/:departureDate" element={<AssignedTripDetails />} />
              <Route path="/reports/coordinators/:coordinatorId/not-scanned" element={<CoordinatorReportDetails />} />
              <Route
                path="/reports/coordinators/:coordinatorId/destination/:countryId"
                element={<CoordinatorDestinationReport />}
              />
              <Route path="/reports-by-user" element={<ReportsByUser />} />
              <Route path="/reports-by-user/:id" element={<UserReportDetails />} />

              <Route path="/notifications" element={<SendNotification />} />

              {/* Trip Reports (Guide Report) */}
              <Route path="/trip-reports" element={<TripReportsList />} />
              <Route path="/trip-reports/:countryId/:departureDate/:guideId" element={<TripReportEdit />} />
              <Route path="/trip-reports/:countryId/:departureDate/:guideId/view" element={<TripReportView />} />

              <Route path="/adminusers" element={<AdminAccess />}>
                <Route index element={<AdminUsers />} />
                <Route path="/adminusers/add" element={<AddAdminUser />} />
                <Route path="/adminusers/:id" element={<AdminUserDetail />} />
                <Route path="/adminusers/:id/coordinator-view" element={<CoordinatorView />} />
              </Route>
              <Route path="/roles" element={<AdminAccess />}>
                <Route index element={<Roles />} />
                <Route path="/roles/add" element={<RoleForm />} />
                <Route path="/roles/:id" element={<RoleForm />} />
              </Route>
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            {/* Public page with instructions for deleting an account */}
            <Route path="/account-deletion" element={<AccountDeletion />} />

            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;

const CoordinatorRedirect = () => {
  return <Dashboard />;
};

const Layout = () => {
  const [isSidebar, setIsSidebar] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <Sidebar isSidebar={isSidebar} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <main className="content">
        <Topbar setIsSidebar={setIsSidebar} setMobileOpen={setMobileOpen} />
        <PermissionGuard>
          <Outlet />
        </PermissionGuard>
      </main>
    </>
  );
};
